import coverUrl from './upload-cover-pic.html';
import profileUrl from './upload-square-pic.html';

export const uploadCoverPicComponent = {
    bindings: {
        pageName: '@',
        onUpload: '&',
        type: '@',
        onRemove: '&',
        defaultCoverPic: '@',
        showSqurePhoto: '@',
        isDisable: '<',
        headingText: '@',
        isCoverPhotoRequired: '@',
        isRatioChange: '@'   
    },
    template: '<div ng-include="$ctrl.templateUrl">',
    controller: class UploadCoverPicComponent {
        constructor($timeout, $parse, ImageCropService, ImageUploadService, ApiService, toastr, $scope) {
            'ngInject';

            this.$timeout = $timeout;
            this.$parse = $parse;
            this.imageCropService = ImageCropService;
            this.imageUploadService = ImageUploadService;
            this.apiService = ApiService;
            this.toastr = toastr;
            this.$scope = $scope;
        }

        $onInit() {
            this._isCoverPhotoRequired = this.$parse(this.isCoverPhotoRequired || 'false')(false);
            this._showSqurePhoto = this.$parse(this.showSqurePhoto || 'false')(false);
            this._isRatioChange = this.$parse(this.isRatioChange || 'false')(false);
            this.title = this.pageName;
            if(this.defaultCoverPic) {
                this._isCoverPhotoRequired = false;
            }
            this.imageSrc = this.defaultCoverPic ? this.apiService.getImageUrl(this.defaultCoverPic) : this._getDefaultPath();
            this.selectedImage = '';
            this.removeClass = this.type === 'banner' ? 'remove-button-margin': '';
            this.templateUrl = this._showSqurePhoto ? profileUrl : coverUrl;
            this.type = this.type ? this.type : this._showSqurePhoto ? "profile" : "cover" ;
            if (this.headingText) {
                this.title = this.headingText;
            }
        }

        _getDefaultPath() {
            if(this.type === "staffProfile") {
                return '/./images/Staff_default.jpg';
            }

            if (this._showSqurePhoto) {
                return '/./images/placeholder.png';
            }

            return '/./images/cover-pic.jpg';
        }

        onFileChange() {
            const pattern = /^image/g;
            const isImage = pattern.test(this.selectedImage.type);
            if (this.selectedImage && isImage) {
                (this.type === 'profile' || this.type === 'siteLogo') ? _upload.call(this, this.selectedImage) : _cropImage.call(this);
            } else {  
                this.toastr.error("Invalid image file");          
            }

            function _cropImage(){
                this.imageCropService.cropImage({
                    image: this.selectedImage,
                    onCrop: _upload.bind(this),
                    onCancel: _onCancel.bind(this),
                    type: this.type
                });
            }

            function _onCancel() {
                if(this.defaultCoverPic === "") {
                    this.selectedImage = "";
                }
            }

            function _upload(image) {
                this.imageUploadService.upload({
                    image: image,
                    name: this.selectedImage.name,
                    container: this.pageName
                }).then((details) => {
                    const _details = details.data.data;
                    this.imageSrc = this.apiService.getImageUrl(_details.uuid);
                    this.fileName = this.selectedImage.name;
                    this.onUpload({
                        $event: {
                            details: _details
                        }
                    });
                    this._isCoverPhotoRequired = false;
                }).catch((err) => {
                    this.toastr.error("Image upload failed");
                });
            }
        }

        _onRemove() {
            this.fileName = '';
            this.selectedImage = '';
            this.defaultCoverPic = '';
            this.hideRemove = true;
            this.imageSrc = this._showSqurePhoto ? '/./images/placeholder.png' : '/./images/cover-pic.jpg';
            this._isCoverPhotoRequired = this.$parse(this.isCoverPhotoRequired || 'false')(false);
            this.onRemove();
        }

        $onChanges(changes) {
            if (changes.defaultCoverPic) {
                this.imageSrc = this.apiService.getImageUrl(changes.defaultCoverPic.currentValue);
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/upload-cover-pic/upload-cover-pic.component.js